<template>
  <tr>
    <th><p class="item3">{{itemLabel}}<span class="font_orange">*</span></p></th>
    <td>
      <p>
        <input
          type="text"
          size="20"
          class="form_basic"
          v-model="userState[`${itemName}`]"
          :class="{error_outline: userErrorState.errors[`${itemName}`]}"
        />
        <span class="font_orange">　{{ $t('phoneNumber.note') }}</span>
      </p>
      <p>
        <span class="iferror" v-show="userErrorState.errors[`${itemName}_required`]">
          ▲ {{ $t('required') }}
        </span>
      </p>
    </td>
  </tr>
</template>

<script>
import { defineComponent } from 'vue'
import { useUserState } from '@/components/lib/user/composables/useUserState'
import { useUserErrorState } from '@/components/lib/user/composables/useUserErrorState'

export default defineComponent({
  props: {
    itemLabel: {
      type: String,
      required: true,
    },
    itemName: {
      type: String,
      required: true,
      validator(value) {
        return [
          'phone_number',
          'company_hq_phone_number',
        ].includes(value)
      },
    },
  },
  setup() {
    const { userState } = useUserState()
    const { userErrorState } = useUserErrorState()

    return {
      userState,
      userErrorState,
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
